import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Col, FormGroup, FormText, Input, Label, Row, Form } from "reactstrap";
import { failed, success } from "../../../utils/Tostify";
import { formikResetPass, formikResetPatientNewPassword } from "../Constant";
import {
  patientResetPassword,
  patientManualPasswordChange,
  sendInviteToPatient,
  updatePatientById
} from "../../../api/patient";
import Loader from "../../../components/Loader/Loader";

const AddPatientPortal = ({toggleTab,patientDeatils}) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let token = useSelector((state) => state.userReducer.token);
  const [isManualPassword, setIsManualPassword] = useState(false);
  const [sharedEmail, setSharedEmail] = useState(""); // Shared state for email
  const [emailError, setEmailError] = useState(null);

  const formik = useFormik({
    ...formikResetPass,
    onSubmit: async (values) => {
      let res;
      try {
        setIsLoading(true);
        res = await patientResetPassword({ values, token, dispatch });
        if (res?.status === "SUCCESS") {
          setIsLoading(false);
          success(res?.message);
          // toggleTab("7");
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  const formikMannulPassword = useFormik({
    ...formikResetPatientNewPassword,
    onSubmit: async (values) => {
      if (!sharedEmail) {
        // Check if email exists
        setEmailError("Email is Required.");
        return;
      }
      let res;
      try {
        setIsLoading(true);
        let payload = { ...values, email: sharedEmail };
        res = await patientManualPasswordChange({
          values: payload,
          token,
          dispatch
        });
        if (res?.status === "SUCCESS") {
          setIsLoading(false);
          success(res?.message);
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  const sendInvite = async () => {
    if (!sharedEmail) {
      // Check if email exists
      setEmailError("Email is Required.");
      return;
    }
    let res;
    try {
      setIsLoading(true);
      let payload = { email: sharedEmail, userId:patientDeatils._id, phone: patientDeatils?.telecom[1]?.value };
      res = await sendInviteToPatient({ values: payload, token, dispatch });
      if (res?.status === "SUCCESS") {
        setIsLoading(false);
        success(res?.message);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed(res?.message);
    }
  };

  const formikPortalPermissions = useFormik({
    initialValues: {
      permissions: [],
      patientPortalNote: ""
    },
    onSubmit: async (values) => {
      setEmailError(null); // Clear error if email exists
      setIsLoading(true);
      try {
        const res = await updatePatientById({ payload: values, token, dispatch ,patientId : patientDeatils?._id});
        if (res?.status === "SUCCESS") {
          success(res?.message);
        } else {
          failed(res?.message);
        }
      } catch (error) {
        failed(error.message);
      } finally {
        setIsLoading(false);
      }
    }
  });

  const handlePermissionChange = (permission) => {
    const { permissions } = formikPortalPermissions.values;

    if (permissions.includes(permission)) {
      formikPortalPermissions.setFieldValue(
        'permissions',
        permissions.filter((perm) => perm !== permission) // Remove permission if unchecked
      );
    } else {
      formikPortalPermissions.setFieldValue(
        'permissions',
        [...permissions, permission] // Add permission if checked
      );
    }
  };

  useEffect(() => {
    if (patientDeatils) {
      setSharedEmail(patientDeatils.telecom?.find(t => t.system === 'email')?.value || "");
      formik.setValues({
        email: patientDeatils.telecom?.find(t => t.system === 'email')?.value || ""
      });
      formikPortalPermissions.setValues({
        permissions: patientDeatils.permissions ? patientDeatils.permissions : [] ,
        patientPortalNote: patientDeatils?.patientPortalNote
      });
    }
  }, [patientDeatils]);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <div className="patient_portal_block mt-3">
        <h3 className="mb-3">Patient Portal Settings</h3>
        <Row>
          <Col lg={12}>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="align-items-start mb-3">
                <Col lg={3}>
                  <Label for="exampleEmail">Patient User Name :</Label>
                </Col>
                <Col lg={9}>
                  <Input
                    id="exampleEmail"
                    name="email"
                    placeholder="Email"
                    disabled={true}
                    type="email"
                    value={formik.values.email}
                    onChange={(e) => {
                      formik.setFieldValue("email", e.target.value);
                      setSharedEmail(e.target.value);
                      setEmailError("");
                    }}
                  />
                  {formik.touched["email"] && formik.errors["email"] ? (
                    <span style={{ color: "red" }}>
                      {formik.errors["email"]}
                    </span>
                  ) : null}
                  {emailError && (
                    <span style={{ color: "red" }}>{emailError}</span>
                  )}
                  <FormText>
                    Caution:{" "}
                    <span>
                      Patient will have to reset their password if you change
                      username. Username must be unique email.
                    </span>
                  </FormText>
                </Col>
              </Row>
              <Row className="align-items-start mb-4">
                <Col lg={3}>
                  <Label for="exampleEmail">Patient Password :</Label>
                </Col>
                <Col lg={9}>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                  <button type="submit" disabled={!patientDeatils?.isAccountCreated}>Reset Password</button>
                  <FormText>
                      Reset and send password details to{" "}
                      <a href={`mailto:${formik?.values.email}`}>{formik?.values.email}</a>.
                    </FormText>
                  </div>
                </Col>
              </Row>
            </Form>
            <Row className="align-items-start mb-4">
              <Col lg={3}>
                <Label for="exampleEmail">Invite Patient to Portal:</Label>
              </Col>
              <Col lg={9}>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <button
                    onClick={() => sendInvite()}
                    disabled={
                      patientDeatils?.isAccountCreated ||
                      !patientDeatils?.telecom?.some(
                        (item) => item?.system === "email" && item?.value
                      )
                    }
                  >
                    Send Registration Request
                  </button>
                  <FormText>
                  Send Registration request for patient account to {formik?.values.email}.
                  </FormText>
                </div>
              </Col>
            </Row>
            <Form onSubmit={formikPortalPermissions.handleSubmit}>
              <Row className="align-items-start mb-3">
                <Col lg={3}>
                  <Label for="exampleEmail">Patient Portal Permissions:</Label>
                </Col>
                <Col lg={9}>
                  <div className="first_block d-flex align-items-center gap-2">
                    <p>Patient can login</p>
                    <p>
                      <div className="toggle">
                        <input
                          type="checkbox"
                          id="canLogin"
                          checked={formikPortalPermissions.values.permissions.includes('canLogin')}
                          onChange={() => handlePermissionChange('canLogin')}
                        />
                        <label htmlFor="canLogin"></label>
                      </div>
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="align-items-start">
                <Col lg={3}>
                  <Label for="exampleEmail">Patient Portal Access Notes:</Label>
                </Col>
                <Col lg={9}>
                  <div className="d-flex align-items-center gap-2">
                    <Input
                      id="exampleText"
                      type="textarea"
                      name="patientPortalNote"
                      value={formikPortalPermissions.values.patientPortalNote}
                      onChange={formikPortalPermissions.handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-center mt-4">
                <button className="save_change" type="submit">
                  Save Changes
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AddPatientPortal;
